"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statReducerBase = void 0;
var tslib_1 = require("tslib");
var statReducerBase = function (state, action) {
    var _a;
    var _b;
    if (!action) {
        return state || null;
    }
    if (action.type === 'INCREMENT_WATCHER' && action.watcherType) {
        var previousWatcherCount = (state === null || state === void 0 ? void 0 : state.watcherCounts) || {};
        var previousCount = ((_b = state === null || state === void 0 ? void 0 : state.watcherCounts) === null || _b === void 0 ? void 0 : _b[action.watcherType]) || 0;
        var newCount = previousCount + action.increment;
        var newWatcherCountMutable = tslib_1.__assign(tslib_1.__assign({}, previousWatcherCount), (_a = {}, _a[action.watcherType] = newCount < 0 ? 0 : newCount, _a));
        return tslib_1.__assign(tslib_1.__assign({}, state), { watcherCounts: newWatcherCountMutable });
    }
    return state || null;
};
exports.statReducerBase = statReducerBase;
